var render, staticRenderFns
import script from "./StopStatusHistoryMarker.vue?vue&type=script&lang=js&"
export * from "./StopStatusHistoryMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76cd12d8')) {
      api.createRecord('76cd12d8', component.options)
    } else {
      api.reload('76cd12d8', component.options)
    }
    
  }
}
component.options.__file = "src/pages/Map/components/StopStatusHistoryMarker.vue"
export default component.exports